require('./bootstrap');
require('@fortawesome/fontawesome-free/js/all.min.js');